(() => {
  if (customElements.get('collection-454')) return;
  const selection = new Map();
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  class Collection454 extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.classList.add('js-ready');
      this.text = JSON.parse(this.querySelector('[data-collection-text]').textContent);
      this.mobile = matchMedia('(max-width:989px)');
      this.form = this.querySelector('[data-filter-form]');
      this.filterDialog = this.querySelector('[data-filter-dialog]');
      this.syncViewport = () => {
        if (this.filterDialog.open) this.filterDialog.close();
        if (!this.mobile.matches) this.filterDialog.setAttribute('open','');
      };
      this.syncViewport();
      this.mobile.addEventListener('change',this.syncViewport);
      this.addEventListener('click', event => this.handleClick(event));
      this.addEventListener('change', event => this.handleChange(event));
      this.addEventListener('input', event => {
        if (!event.target.matches('[data-search-values]')) return;
        const search = event.target.value.trim().toLocaleLowerCase();
        event.target.closest('details').querySelectorAll('[data-filter-value]').forEach(row => row.hidden = !row.textContent.toLocaleLowerCase().includes(search));
      });
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        this.navigate(this.formURL(),true,true);
      });
      this.popstate = () => this.navigate(location.href,false,false);
      window.addEventListener('popstate',this.popstate);
      this.refreshCompare();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.mobile?.removeEventListener('change',this.syncViewport);
      window.removeEventListener('popstate',this.popstate);
    }
    formURL() {
      const url = new URL(this.dataset.url,new URL(document.baseURI).origin);
      const params = new URLSearchParams(new FormData(this.form));
      [...params.entries()].forEach(([key,value]) => { if (!value) params.delete(key); });
      const view = new URL(document.baseURI).searchParams.get('view');
      if (view) params.set('view',view);
      url.search = params.toString();
      return url;
    }
    handleChange(event) {
      const target = event.target;
      if (target.matches('[data-compare-select]')) {
        if (target.checked) {
          if (selection.size === 3) { target.checked = false; this.announce(this.text.limit); return; }
          const data = JSON.parse(target.closest('article').querySelector('[data-compare-data]').textContent);
          selection.set(data.id,data);
        } else selection.delete(target.value);
        this.refreshCompare();
      } else if (target.matches('[data-desktop-sort]')) {
        this.form.querySelector('[data-sort-input]').value = target.value;
        this.navigate(this.formURL());
      } else if (this.form.contains(target) && !this.mobile.matches && target.name) {
        this.navigate(this.formURL());
      }
    }
    handleClick(event) {
      const target = event.target.closest('a,button');
      if (!target) return;
      if (target.matches('[data-collection-link]')) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.navigate(target.href,true,target.closest('.c454-pagination') !== null);
      } else if (target.matches('[data-open-filters]')) {
        this.filterDialog.showModal();
      } else if (target.matches('[data-open-menu]')) {
        this.querySelector('[data-menu-dialog]').showModal();
      } else if (target.matches('[data-close-dialog]')) {
        target.closest('dialog').close();
      } else if (target.matches('[data-open-compare]')) {
        this.renderComparison();
        this.querySelector('[data-compare-dialog]').showModal();
      } else if (target.matches('[data-clear-compare]')) {
        selection.clear(); this.refreshCompare();
      } else if (target.matches('[data-remove-compare]')) {
        selection.delete(target.dataset.removeCompare); this.refreshCompare();
        if (selection.size < 2) this.querySelector('[data-compare-dialog]').close();
        else this.renderComparison();
      }
    }
    announce(message) { this.querySelector('[data-status]').textContent = message; }
    async navigate(destination,push = true,scroll = false) {
      const url = new URL(destination,new URL(document.baseURI).origin);
      if (url.origin !== new URL(document.baseURI).origin) { location.assign(url.href); return; }
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.setAttribute('aria-busy','true');
      this.announce(this.text.loading);
      const request = new URL(url);
      request.searchParams.set('section_id',this.dataset.section);
      try {
        const response = await fetch(request,{signal,headers:{'X-Requested-With':'XMLHttpRequest'}});
        if (!response.ok) throw new Error('Collection response failed');
        const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
        const replacement = parsed.querySelector('collection-454');
        if (!replacement || signal.aborted) throw new Error('Collection section missing');
        const opened = new Set([...this.querySelectorAll('.c454-filter-group[open]')].map(detail => detail.querySelector('input[name]')?.name));
        replacement.querySelectorAll('.c454-filter-group').forEach(detail => { if (opened.has(detail.querySelector('input[name]')?.name)) detail.open = true; });
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        if (push && location.protocol.startsWith('http')) history.pushState({},'',url);
        if (!location.protocol.startsWith('http')) document.querySelector('base').href = url.href;
        this.replaceWith(replacement);
        replacement.querySelector('[data-result-count]')?.focus({preventScroll:true});
        if (scroll) replacement.querySelector('.c454-shopping').scrollIntoView({block:'start',behavior:'instant'});
        replacement.announce(replacement.querySelector('[data-result-count]').textContent.trim());
        setTimeout(() => { if (replacement.isConnected) replacement.announce(''); },2500);
      } catch (error) {
        if (error.name === 'AbortError' || signal.aborted) return;
        this.removeAttribute('aria-busy');
        this.announce(this.text.error);
        location.assign(url.href);
      }
    }
    refreshCompare() {
      this.querySelectorAll('[data-compare-select]').forEach(input => input.checked = selection.has(input.value));
      const tray = this.querySelector('[data-compare-tray]');
      if (!tray) return;
      tray.hidden = selection.size === 0;
      tray.querySelector('[data-compare-count]').textContent = this.text.selected.replace('__COUNT__',selection.size);
      tray.querySelector('[data-open-compare]').disabled = selection.size < 2;
    }
    renderComparison() {
      const products = [...selection.values()];
      const e = escapeHTML;
      let html = '<table><thead><tr><th scope="col">'+e(this.text.name)+'</th>';
      products.forEach(product => {
        html += '<th scope="col">'+(product.image ? '<img src="'+e(product.image)+'" alt="'+e(product.title)+'" width="240" height="180">':'')+'<a href="'+e(product.url)+'">'+e(product.title)+'</a><button type="button" data-remove-compare="'+e(product.id)+'" aria-label="'+e(this.text.remove.replace('__TITLE__',product.title))+'">× '+e(this.text.remove.replace('__TITLE__',product.title))+'</button></th>';
      });
      html += '</tr></thead><tbody>';
      Object.entries(this.text.fields).forEach(([key,label]) => {
        if (!products.some(product => product[key] && product[key] !== 'Default Title')) return;
        html += '<tr><th scope="row">'+e(label)+'</th>'+products.map(product => '<td>'+e(product[key] && product[key] !== 'Default Title' ? product[key] : this.text.empty)+'</td>').join('')+'</tr>';
      });
      html += '</tbody></table>';
      this.querySelector('[data-compare-table]').innerHTML = html;
    }
  }
  customElements.define('collection-454',Collection454);
})();
